var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slider-box",class:[_setup.isSliderOpen && 'slider-open'],on:{"click":_setup.toggleSlider}},[_c('span',{staticClass:"slider-block"})])
}
var staticRenderFns = []

export { render, staticRenderFns }